import useOnRightClickAnnotation from './useOnRightClickAnnotation';

export default useOnRightClickAnnotation;